import type { PerResidentResponse } from '@lmc/ts-common'
import { Spinner } from 'components/generic'
import dayjs from 'dayjs'
import NoDataEmptyState from 'screens/Reports/RiskAssessmentDashboard/components/EmptyStates/NoDataEmptyState'
import type { PerResidentFilters } from '../DashboardFilters/DashboardFilters'
import DashboardTable from '../DashboardTable/DashboardTable'

interface DashboardBodyProps {
  isLoading: boolean
  filterParams: PerResidentFilters
  data?: PerResidentResponse
}

export const DashboardBody = ({
  isLoading,
  filterParams,
  data
}: DashboardBodyProps) => {
  const { rangePicker } = filterParams

  if (isLoading) {
    return <Spinner />
  }

  if (!data?.result?.length) {
    return <NoDataEmptyState />
  }

  return (
    <DashboardTable
      from={rangePicker?.[0] || dayjs()}
      to={rangePicker?.[1] || dayjs()}
      dataSource={data.result || []}
    />
  )
}

export default DashboardBody
